import React, { useState } from "react";
import styled from "styled-components";
import { FaSearch } from "react-icons/fa";
import { useContext } from "react";
import { MiniStoreThemeContext } from "../../../MiniStoreContexts/MiniStoreThemeContext";
import { fetchCategories } from "../../../DataApi/miniStore/fetchCategories";
import { fetchCategoryProducts } from "../../../DataApi/miniStore/fetchCategoryProducts";
import { useLocation, useParams } from "react-router-dom";
import { isEqual } from "lodash";
import { CartContext } from "../../../contexts/MiniStore/CartContext";
import { fetchTopSelling } from "../../../DataApi/miniStore/fetchTopSelling";
import { fetchNewArrivals } from "../../../DataApi/miniStore/fetchNewArrivals";
import { fetchLimitedStocks } from "../../../DataApi/miniStore/fetchLimitedStocks";
import { fetchPromotions } from "../../../DataApi/miniStore/fetchPromotions";
import { preventDefault } from "@fullcalendar/core/internal";
import { fetchSearchProducts } from "../../../DataApi/miniStore/fetchSearchProducts";

const SearchBarGeneral = () => {
  const { theme } = useContext(MiniStoreThemeContext);
  const location = useLocation();
  const { categories, setCategories, products, setProducts, searchBy } =
    useContext(CartContext);
  const { categorySlug, id } = useParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // console.log("location.pathname", location.pathname);
  // Generic Search Function
  const getFormatedList = (list) => {
    const formattedList = list?.map((product) => ({
      id: product?.id,
      title: product?.name || "",
      rating: product?.rating_avg || 0,
      quantity: 1,
      currency: product?.currency_id?.[1],
      price: product?.lst_price || 0,
      newPrice: product?.pricelist_price.toFixed(2) || 0,
      discount: 0,
      description: product?.description_sale || "",
      image_1920: product?.img_url,
      hasVariant: product?.attribute_line_ids?.length > 0 ? true : false,
      availableQty: product?.qty_available || 0,
      variant_ids: product?.product_variant_ids || [],
    }));
    return formattedList;
  };
  const handleSearch = async (query) => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      let results = [];
      if (location.pathname === "/storefront/home") {
        results = await fetchPromotions({ query });
        const formattedNewArrivals = getFormatedList(results.result);
        if (!isEqual(products, formattedNewArrivals)) {
          setProducts(formattedNewArrivals);
        }
      } else if (location.pathname === "/storefront/home/new-arrivals") {
        results = await fetchNewArrivals({ query });
        const formattedNewArrivals = getFormatedList(results.result);
        if (!isEqual(products, formattedNewArrivals)) {
          setProducts(formattedNewArrivals);
        }
      } else if (location.pathname === "/storefront/home/limited-stock") {
        results = await fetchLimitedStocks({ query });
        const formattedLimitedStocks = getFormatedList(results.result);
        if (!isEqual(products, formattedLimitedStocks)) {
          setProducts(formattedLimitedStocks);
        }
      } else if (location.pathname === "/storefront/home/top-selling") {
        results = await fetchTopSelling({ query });
        const formattedTopSelling = getFormatedList(results.result);
        if (!isEqual(products, formattedTopSelling)) {
          setProducts(formattedTopSelling);
        }
      } else if (location.pathname === "/storefront/home/top-selling") {
        results = await fetchTopSelling({ query });
        const formattedTopSelling = getFormatedList(results.result);
        if (!isEqual(products, formattedTopSelling)) {
          setProducts(formattedTopSelling);
        }
      } else if (location.pathname === "/storefront/shop") {
        if (searchBy === "product") {
          results = await fetchSearchProducts({ query });
          const formattedSearchProducts = getFormatedList(results.result);

          // if (!isEqual(products, formattedSearchProducts)) {

          setProducts(formattedSearchProducts);
          // }
        } else {
          results = await fetchCategories({ query });
          const formattedCategories = results.result.map((category) => ({
            id: category?.id,
            title: category?.name,
            products: category?.products.map((product) => ({
              id: product?.id,
              title: product?.name || "",
              rating: product?.rating_avg || 0,
              quantity: product?.quantity || 10,
              currency: "OMR",
              price: product?.lst_price || 0,
              discount: 0,
              description: product?.description_sale || "",
              image_1920: product?.img_url,
            })),
          }));
          if (!isEqual(categories, formattedCategories)) {
            // console.log("true");
            setCategories(formattedCategories);
          }
        }
      } else if (categorySlug && id) {
        // Searching within a specific category
        results = await fetchCategoryProducts({
          public_categ_id: +id, // Extracted from the URL
          query: query,
          limit: 10,
          offset: 0,
        });
        const formattedCategoryProducts = results?.result.map((product) => ({
          id: product?.id,
          title: product?.name || "",
          rating: product?.rating_avg || 0,
          quantity: product?.quantity || 10,
          currency: "OMR",
          price: product?.lst_price || 0,
          discount: 0,
          description: product?.description_sale || "",
          image_1920: product?.img_url,
        }));
        if (!isEqual(products, formattedCategoryProducts)) {
          setProducts(formattedCategoryProducts);
        }
      }
      // console.log("Search Results:", results);
    } catch (error) {
      console.error("Search error:", error);
    }
    setIsLoading(false);
  };

  return (
    <SearchWrapper
      theme={theme}
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch(searchQuery);
      }}
    >
      <SearchInput
        theme={theme}
        placeholder="Search..."
        value={searchQuery}
        onChange={(e) => {
          const query = e.target.value;
          setSearchQuery(query);
          if (query === "") {
            handleSearch(""); // Fetch all data when input is cleared
          }
        }}
      />
      <SearchIconWrapper
        theme={theme}
        onClick={() => handleSearch(searchQuery)}
      >
        <FaSearch />
      </SearchIconWrapper>
    </SearchWrapper>
  );
};

export default SearchBarGeneral;

// Styled Components
const SearchWrapper = styled.form`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  margin: 1.5rem 0rem;
`;

const SearchInput = styled.input`
  width: 100%;
  height: 3.5rem;
  border: none;
  padding: 12px 16px;
  padding-right: 50px;
  background-color: #fff;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  font-size: 16px;
  font-family: "Outfit", sans-serif;
  color: ${({ theme }) => theme.primaryColor.primary};
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.primaryColor.primary};
    opacity: 0.8;
  }
`;

const SearchIconWrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background-color: ${({ theme }) => theme.primaryColor.primary};
  color: ${({ theme }) => theme.textColor.primary};
  border-radius: 0.15rem;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
